import * as React from "react";

export const FacebookFeed = ({ mobile }: { mobile?: boolean }) => {
  const fbLink = process.env.FB_LINK;
  const encodedLink = encodeURIComponent(fbLink);
  const className = `facebook-frame-${mobile ? "small" : "big"}`;
  return (
    <>
      {(fbLink && (
        <iframe
          title="Facebook Feed"
          src={`https://www.facebook.com/plugins/page.php?href=${encodedLink}&tabs=timeline&width=300&height=750&small_header=false&adapt_container_width=true&hide_cover=true&show_facepile=true&appId=307742486260819`}
          className={`facebook-frame ${className}`}
          scrolling="no"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          data-testid={className}
        />
      )) || (
        <div data-testid="facebook-missing-env">Facebook Profile not set!</div>
      )}
    </>
  );
};
